module.exports = __webpack_public_path__ + "img/weight-time.9502a0bb.png";